import axios from "axios";

/** Axios instance for public endpoints — no login redirect on 401. */
const publicApi = axios.create({
  baseURL: "https://salonify.co.uk/api",
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
});

export default publicApi;
